module.exports = "https://cdn.dove.it/_next/static/public/assets/channels/logo-google.f2c77c66b355148f88a72dded0757398.png";